module.exports = __webpack_public_path__ + "static/media/image19.c12038cf.JPG";